import React from 'react';
import { getPasswordStrength } from '../../../../utils/passwordValidation';

/** Ambient 3px strength bar + mono label — progress is ambient, never blocking. */
const PasswordStrengthMeter: React.FC<{ password: string }> = ({ password }) => {
  const { strength, label, weak } = getPasswordStrength(password);
  if (!password) return null;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <div className={`tend-progress${weak ? ' is-alert' : ''}`} style={{ flex: 1 }}>
        <i style={{ width: `${strength}%` }} />
      </div>
      <span className="tend-micro">{label}</span>
    </div>
  );
};

export default PasswordStrengthMeter;
